// Controls
// Styles
import { useVirtualContainerStyles } from "./VirtualContainer.styles";
// Utilities
import * as React from "react";
import { InView } from "react-intersection-observer";
/**
 * VirtualContainer wraps around child component (for instance User/Group) helping to lazy load data just when component is rendered
 */ export const VirtualContainer = (props)=>{
    const { containerId, onLoad, children } = props;
    const styles = useVirtualContainerStyles();
    const [hasLoaded, setHasLoaded] = React.useState(false);
    const prevContainerIdRef = React.useRef(null);
    // Reset hasLoaded when containerId changes
    if (prevContainerIdRef.current !== containerId) {
        setHasLoaded(false);
        prevContainerIdRef.current = containerId;
    }
    function handleInViewCallback(inView) {
        if (!hasLoaded && inView) {
            onLoad();
            setHasLoaded(true);
        }
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(InView, {
        onChange: handleInViewCallback,
        triggerOnce: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.anchor
    }))), children);
};
